/* Product Reviews - CSV loader and renderer
 * Reads /assets/reviews.csv (Judge.me/Shopify Product Reviews format)
 * Filters by current product handle, computes stats, renders cards.
 */
(function () {
  if (window.ProductReviewsStore) return;

  // ---------- CSV parser (handles quoted fields with commas and newlines) ----------
  function parseCSV(text) {
    var rows = [];
    var row = [];
    var field = '';
    var i = 0;
    var inQuotes = false;
    var len = text.length;
    while (i < len) {
      var c = text.charAt(i);
      if (inQuotes) {
        if (c === '"') {
          if (text.charAt(i + 1) === '"') {
            field += '"';
            i += 2;
            continue;
          }
          inQuotes = false;
          i++;
          continue;
        }
        field += c;
        i++;
        continue;
      }
      if (c === '"') {
        inQuotes = true;
        i++;
        continue;
      }
      if (c === ',') {
        row.push(field);
        field = '';
        i++;
        continue;
      }
      if (c === '\n' || c === '\r') {
        if (c === '\r' && text.charAt(i + 1) === '\n') i++;
        row.push(field);
        field = '';
        rows.push(row);
        row = [];
        i++;
        continue;
      }
      field += c;
      i++;
    }
    if (field.length > 0 || row.length > 0) {
      row.push(field);
      rows.push(row);
    }
    return rows;
  }

  function rowsToObjects(rows) {
    if (!rows.length) return [];
    var headers = rows[0].map(function (h) { return (h || '').trim().toLowerCase(); });
    var out = [];
    for (var r = 1; r < rows.length; r++) {
      var rr = rows[r];
      if (rr.length === 1 && rr[0].trim() === '') continue;
      var obj = {};
      for (var c = 0; c < headers.length; c++) {
        obj[headers[c]] = (rr[c] !== undefined ? rr[c] : '').trim();
      }
      out.push(obj);
    }
    return out;
  }

  function parsePictures(raw) {
    if (!raw) return [];
    // Allow comma, semicolon, space, or pipe separators
    return raw.split(/[\s,;|]+/).map(function (u) { return u.trim(); }).filter(Boolean);
  }

  function parseRating(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) return 0;
    if (n < 0) n = 0;
    if (n > 5) n = 5;
    return n;
  }

  function parseDate(raw) {
    if (!raw) return null;
    var s = raw.replace(' UTC', 'Z').replace(' ', 'T');
    var d = new Date(s);
    if (isNaN(d.getTime())) {
      d = new Date(raw);
    }
    return isNaN(d.getTime()) ? null : d;
  }

  function formatDate(d) {
    if (!d) return '';
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function obfuscateName(full) {
    if (!full) return 'Anonymous';
    var parts = full.trim().split(/\s+/);
    if (parts.length === 1) return parts[0];
    var first = parts[0];
    var last = parts[parts.length - 1];
    return first + ' ' + last.charAt(0).toUpperCase() + '.';
  }

  function firstLetter(name) {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  }

  // ---------- Loader (cached) ----------
  var cache = null;
  var inflight = null;

  function loadAll(url) {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to load ' + url);
        return r.text();
      })
      .then(function (text) {
        var rows = parseCSV(text);
        var objs = rowsToObjects(rows);
        cache = objs.map(function (o) {
          return {
            title: o.title || '',
            body: o.body || '',
            rating: parseRating(o.rating),
            date: parseDate(o.review_date),
            name: o.reviewer_name || 'Anonymous',
            displayName: obfuscateName(o.reviewer_name || ''),
            initial: firstLetter(o.reviewer_name || ''),
            productHandle: (o.product_handle || '').toLowerCase(),
            reply: o.reply || '',
            pictures: parsePictures(o.picture_urls)
          };
        });
        return cache;
      })
      .catch(function (err) {
        console.warn('[product-reviews] load failed:', err);
        cache = [];
        return cache;
      });
    return inflight;
  }

  function statsFor(reviews) {
    var total = reviews.length;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var sum = 0;
    for (var i = 0; i < reviews.length; i++) {
      var r = Math.round(reviews[i].rating);
      if (r < 1) r = 1;
      if (r > 5) r = 5;
      counts[r]++;
      sum += reviews[i].rating;
    }
    var avg = total ? (sum / total) : 0;
    return { total: total, average: avg, counts: counts };
  }

  // ---------- Renderers ----------
  function starSvg(filled, color, size) {
    var fill = filled ? color : 'none';
    var stroke = color;
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.5" stroke-linejoin="round"><path d="M12 2.5l2.95 6.16 6.8.79-5.05 4.66 1.4 6.69L12 17.6l-6.1 3.2 1.4-6.69L2.25 9.45l6.8-.79z"/></svg>';
  }

  function starsHTML(rating, color, size) {
    var html = '';
    var full = Math.round(rating);
    for (var i = 1; i <= 5; i++) {
      html += starSvg(i <= full, color, size);
    }
    return '<span class="pr-stars" style="--pr-star-size:' + size + 'px;">' + html + '</span>';
  }

  // ---------- Public API ----------
  window.ProductReviewsStore = {
    load: function (url, handle) {
      var h = (handle || '').toLowerCase();
      return loadAll(url).then(function (all) {
        var filtered = h ? all.filter(function (r) { return r.productHandle === h; }) : all.slice();
        // Newest first by default
        filtered.sort(function (a, b) {
          var ta = a.date ? a.date.getTime() : 0;
          var tb = b.date ? b.date.getTime() : 0;
          return tb - ta;
        });
        return { reviews: filtered, stats: statsFor(filtered) };
      });
    },
    starsHTML: starsHTML,
    formatDate: formatDate
  };
})();

// ---------- Component initializers ----------
(function () {
  // If override is pure digits → format with commas; if blank → use real (formatted); else → raw string
  function formatOverrideTotal(override, real) {
    if (override == null) return real.toLocaleString();
    var s = String(override).trim();
    if (s === '') return real.toLocaleString();
    if (/^\d+$/.test(s)) return parseInt(s, 10).toLocaleString();
    return s;
  }
  // Same idea for average: pure number → format to 1 decimal; blank → real; else → raw
  function formatOverrideAvg(override, real) {
    if (override == null) return real.toFixed(1);
    var s = String(override).trim();
    if (s === '') return real.toFixed(1);
    if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s).toFixed(1);
    return s;
  }
  // Numeric value of an override for rendering stars; falls back to real
  function numericFromOverride(override, real) {
    if (override == null) return real;
    var s = String(override).trim();
    if (s === '') return real;
    var m = s.match(/[\d.]+/);
    if (!m) return real;
    var n = parseFloat(m[0]);
    return isNaN(n) ? real : n;
  }

  function initTeasers() {
    var teasers = document.querySelectorAll('[data-pr-teaser]:not([data-pr-init])');
    teasers.forEach(function (el) {
      el.setAttribute('data-pr-init', '1');
      var url = el.getAttribute('data-pr-url');
      var handle = el.getAttribute('data-pr-handle');
      var color = el.getAttribute('data-pr-star-color') || '#FF7A8A';
      var size = parseInt(el.getAttribute('data-pr-star-size') || '16', 10);
      var displayedTotal = el.getAttribute('data-pr-display-total');
      var displayedAvg = el.getAttribute('data-pr-display-avg');
      var template = el.getAttribute('data-pr-text') || '{count} reviews';
      var target = el.getAttribute('data-pr-target') || '#product-reviews';

      window.ProductReviewsStore.load(url, handle).then(function (data) {
        var totalDisplay = formatOverrideTotal(displayedTotal, data.stats.total);
        var avgDisplay = formatOverrideAvg(displayedAvg, data.stats.average);
        var avgForStars = numericFromOverride(displayedAvg, data.stats.average);

        var starsEl = el.querySelector('.pr-teaser-stars');
        var textEl = el.querySelector('.pr-teaser-text');
        if (starsEl) starsEl.innerHTML = window.ProductReviewsStore.starsHTML(avgForStars, color, size);
        if (textEl) {
          textEl.textContent = template
            .replace('{count}', totalDisplay)
            .replace('{avg}', avgDisplay)
            .replace('{rating}', avgDisplay);
        }
      });

      el.addEventListener('click', function (e) {
        var t = document.querySelector(target);
        if (t) {
          e.preventDefault();
          t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initSections() {
    var sections = document.querySelectorAll('[data-pr-section]:not([data-pr-init])');
    sections.forEach(function (el) {
      el.setAttribute('data-pr-init', '1');
      var url = el.getAttribute('data-pr-url');
      var handle = el.getAttribute('data-pr-handle');
      var color = el.getAttribute('data-pr-star-color') || '#FF7A8A';
      var accent = el.getAttribute('data-pr-accent') || color;
      var displayedTotal = el.getAttribute('data-pr-display-total');
      var displayedAvg = el.getAttribute('data-pr-display-avg');
      var perPage = parseInt(el.getAttribute('data-pr-per-page') || '6', 10);
      var productImageUrl = el.getAttribute('data-pr-product-image') || '';
      var productTitle = el.getAttribute('data-pr-product-title') || '';
      var verifiedLabel = el.getAttribute('data-pr-verified-label') || 'Verified buyer';
      var purchasedLabel = el.getAttribute('data-pr-purchased-label') || 'PURCHASED';

      var avgEl = el.querySelector('.pr-summary-avg');
      var avgStarsEl = el.querySelector('.pr-summary-stars');
      var totalEl = el.querySelector('.pr-summary-total');
      var breakdownEl = el.querySelector('.pr-breakdown');
      var listEl = el.querySelector('.pr-list');
      var loadMoreBtn = el.querySelector('.pr-load-more');
      var sortSel = el.querySelector('.pr-sort');
      var filterBtns = el.querySelectorAll('[data-pr-filter]');
      var emptyEl = el.querySelector('.pr-empty');

      var state = { reviews: [], filter: 0, sort: 'newest', shown: 0, stats: null };

      function applyFilterSort() {
        var list = state.reviews.slice();
        if (state.filter > 0) {
          list = list.filter(function (r) { return Math.round(r.rating) === state.filter; });
        }
        if (state.sort === 'highest') {
          list.sort(function (a, b) { return b.rating - a.rating; });
        } else if (state.sort === 'lowest') {
          list.sort(function (a, b) { return a.rating - b.rating; });
        } else {
          list.sort(function (a, b) {
            var ta = a.date ? a.date.getTime() : 0;
            var tb = b.date ? b.date.getTime() : 0;
            return tb - ta;
          });
        }
        return list;
      }

      function escapeHTML(s) {
        return String(s || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function reviewCard(r) {
        var stars = window.ProductReviewsStore.starsHTML(r.rating, color, 14);
        var pics = '';
        if (r.pictures && r.pictures.length) {
          pics = '<div class="pr-card-photos">' + r.pictures.map(function (u) {
            return '<a class="pr-photo" href="' + escapeHTML(u) + '" target="_blank" rel="noopener"><img loading="lazy" src="' + escapeHTML(u) + '" alt=""></a>';
          }).join('') + '</div>';
        }
        var reply = '';
        if (r.reply) {
          reply = '<div class="pr-card-reply"><strong>Store reply:</strong> ' + escapeHTML(r.reply) + '</div>';
        }
        var purchased = '';
        if (productImageUrl) {
          purchased = '<div class="pr-card-purchased">' +
            '<img src="' + escapeHTML(productImageUrl) + '" alt="' + escapeHTML(productTitle) + '">' +
            '<div><div class="pr-purchased-label">' + escapeHTML(purchasedLabel) + '</div>' +
            '<div class="pr-purchased-title">' + escapeHTML(productTitle) + '</div></div>' +
            '</div>';
        }
        return '<article class="pr-card">' +
          '<header class="pr-card-head">' +
            '<div class="pr-avatar" aria-hidden="true">' + escapeHTML(r.initial) + '</div>' +
            '<div class="pr-card-meta">' +
              '<div class="pr-card-name">' + escapeHTML(r.displayName) +
                ' <span class="pr-verified" title="' + escapeHTML(verifiedLabel) + '">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22b07a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
                  '<span>' + escapeHTML(verifiedLabel) + '</span>' +
                '</span>' +
              '</div>' +
            '</div>' +
            '<div class="pr-card-date">' + escapeHTML(window.ProductReviewsStore.formatDate(r.date)) + '</div>' +
          '</header>' +
          '<div class="pr-card-stars">' + stars + '</div>' +
          (r.title ? '<h4 class="pr-card-title">' + escapeHTML(r.title) + '</h4>' : '') +
          '<div class="pr-card-body">' + escapeHTML(r.body).replace(/\n/g, '<br>') + '</div>' +
          pics +
          reply +
          purchased +
        '</article>';
      }

      function renderList(reset) {
        var list = applyFilterSort();
        if (reset) {
          state.shown = 0;
          listEl.innerHTML = '';
        }
        var nextShown = Math.min(state.shown + perPage, list.length);
        var slice = list.slice(state.shown, nextShown);
        var html = slice.map(reviewCard).join('');
        listEl.insertAdjacentHTML('beforeend', html);
        state.shown = nextShown;
        if (loadMoreBtn) {
          if (state.shown >= list.length) loadMoreBtn.style.display = 'none';
          else loadMoreBtn.style.display = '';
        }
        if (emptyEl) {
          emptyEl.style.display = list.length === 0 ? '' : 'none';
        }
      }

      function renderSummary() {
        var s = state.stats || { total: 0, average: 0, counts: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 } };
        var totalDisplay = formatOverrideTotal(displayedTotal, s.total);
        var avgDisplay = formatOverrideAvg(displayedAvg, s.average);
        var avgForStars = numericFromOverride(displayedAvg, s.average);
        if (avgEl) avgEl.textContent = avgDisplay;
        if (avgStarsEl) avgStarsEl.innerHTML = window.ProductReviewsStore.starsHTML(avgForStars, color, 22);
        if (totalEl) totalEl.textContent = 'Based on ' + totalDisplay + ' Reviews';
        if (breakdownEl) {
          var realTotal = s.total || 1;
          var html = '';
          for (var stars = 5; stars >= 1; stars--) {
            var c = s.counts[stars] || 0;
            var pct = s.total === 0 ? 0 : Math.round((c / realTotal) * 100);
            html += '<div class="pr-breakdown-row">' +
              '<span class="pr-bd-label">' + stars + ' stars</span>' +
              '<span class="pr-bd-bar"><span class="pr-bd-fill" style="width:' + pct + '%;background:' + accent + ';"></span></span>' +
              '<span class="pr-bd-count">' + pct + '%</span>' +
            '</div>';
          }
          breakdownEl.innerHTML = html;
        }
      }

      window.ProductReviewsStore.load(url, handle).then(function (data) {
        state.reviews = data.reviews;
        state.stats = data.stats;
        renderSummary();
        renderList(true);
      });

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () { renderList(false); });
      }
      if (sortSel) {
        sortSel.addEventListener('change', function () {
          state.sort = sortSel.value;
          renderList(true);
        });
      }
      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(btn.getAttribute('data-pr-filter'), 10) || 0;
          state.filter = v;
          filterBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          renderList(true);
        });
      });
    });
  }

  function init() {
    if (!window.ProductReviewsStore) return;
    initTeasers();
    initSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
